import { Controller } from "@hotwired/stimulus"

// Pede um código novo por e-mail para confirmar uma ação destrutiva.
export default class extends Controller {
  static targets = ["status", "button"]
  static values = { url: String }

  async send(event) {
    event.preventDefault()
    event.stopPropagation()
    this.buttonTarget.disabled = true
    const token = document.querySelector("meta[name='csrf-token']")?.content
    const response = await fetch(this.urlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": token, "Accept": "application/json" },
      credentials: "same-origin"
    })
    this.statusTarget.textContent = response.ok
      ? "Enviamos um código para o seu e-mail. Ele vale 15 minutos."
      : "Não foi possível enviar agora. Tente de novo em alguns minutos."
    setTimeout(() => { this.buttonTarget.disabled = false }, 30000)
  }
}
